<template v-if="ready">

    <div style="position: relative;height:150px;">
        <v-chart ref="vechart" :option="chartOptions" :theme="theme" autoresize/>
    </div>

</template>
<script>

import "echarts";

import VChart from 'vue-echarts';

export default {
    name: "SlaPieEcharts",
    components: {VChart},
    props: ['availability'],
    data() {
        return {
            ready: false,
            theme: this.$store.state.theme,
            availabilityLabel: this.$t('Availability'),
            uptimeLabel: this.$t('Uptime'),
            outageLabel: this.$t('Outage'),
            chartOptions: {},
            background: '#ffffff',
            color: 'black'

        }
    },

    async mounted() {
        if(this.theme === 'dark') {
            this.background = '#444444';
            this.color = 'white';
        }


    },
    methods: {
        renderChart: function() {
            const passed = this.availability?.status_percent;
            const failed = 100 - passed;
            let data = [
                {value: Number(failed.toFixed(3)), name: this.outageLabel},
                {value: Number(passed.toFixed(3)), name: this.uptimeLabel}
            ];

            this.chartOptions = {
                backgroundColor: this.background,
                title: {
                    text: this.availabilityLabel + ' ' + passed + ' %',
                    left: 'center',
                    textStyle: {
                        fontSize: 18,
                        fontStyle: 'normal',
                        color: this.color,
                    }
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    right: 0,
                    top: 'center',
                    textStyle: {
                        color: this.color,
                    }
                },
                series: [
                    {
                        name: this.availabilityLabel,
                        type: 'pie',
                        radius: '50%',
                        data: data,
                        color: ['#CC0000ff', '#00C851'],
                        label: {
                            show: false
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]

            };
            this.ready = true;
            this.$refs.vechart.setOption(this.chartOptions);


        }

    },
    watch: {
        availability: {
            handler: function(val) {
                this.renderChart();
            }
        },
        '$store.state.theme': {
            handler: function(val) {
                if(val === 'light') {
                    this.background = '#ffffff';
                    this.color = 'black';
                }
                if(val === 'dark') {
                    this.background = '#444444';
                    this.color = 'white';
                }
                this.renderChart();
            }
        }
    }
}
</script>


<style scoped>

</style>
